module.exports = __webpack_public_path__ + "static/media/DSC_0140.ba891084.jpg";